import HowToArticle from 'components/articles/HowToArticle';
import { Link as MuiLink } from '@material-ui/core';
import { Link } from 'react-router-dom';
import flipImage from 'components/articles/how-to-flip-an-image.png';

const image = {
  src: flipImage,
  width: 1100,
  height: 680,
  alt: 'PhotoUtils screenshot: how to mirror a photo online',
  title: 'How to flip an image horizontally or vertically',
  type: 'image/png',
};

function HowToFlip() {
  return (
    <HowToArticle
      action="flip"
      description="Learn how to quickly mirror (flip) a photo horizontally or vertically using PhotoUtils online photo editor"
      image={image}
      publishedTime={'2020-11-27T11:27:38'}
      modifiedTime={'2020-11-27T11:27:38'}
    >
      Mirror (flip) a photo horizontally or vertically. Let's say you took a picture in the mirror and want to flip it
      to see everything in the habitual direction. For this, you can use some graphic editor such as Photoshop or GIMP.
      These editors are great but really sophisticated and overloaded with features. Is there a simpler way? Sure! All
      you need is the browser. How to mirror a photo, 3 easy steps:
      <ol>
        <li>
          Upload an image to{' '}
          <MuiLink to="/" component={Link}>
            PhotoUtils
          </MuiLink>{' '}
          and open the <strong>Flip</strong> tool
        </li>
        <li>Select the flip direction</li>
        <li>
          Click <strong>Flip</strong> to download mirrored image
        </li>
      </ol>
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img {...image} />
    </HowToArticle>
  );
}

export default HowToFlip;
